<template>
    <div>
       <span class="font-weight-bold">
                        Induló bérleti díj
                      </span>
        <div class="bootstrap-slider-container">
            <b-form-slider
                v-model="initialPayment"
                :step="1"
                :min="0"
                :max="40"
                @slide-stop="updateInitialPayment()">
            </b-form-slider>
            <div class="row">
                <div class="col-2">0%</div>
                <div class="col-8 text-center">{{ initialPayment }}%</div>
                <div class="col-2 text-right">40%</div>
            </div>
        </div>
        <br/>
    </div>
</template>

<script>
  import Vue from 'vue';
  import { Component } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const priceSearchModule = namespace('price_search');

  @Component
  export default class PriceSearchInitialPaymentSelector extends Vue {
    @priceSearchModule.Getter('getInitialPaymentPercent') initialPaymentPercent;
    @priceSearchModule.Mutation('setInitialPaymentPercent') setInitialPaymentPercent;

    initialPayment = 0;

    created(){
      this.initialPayment = this.initialPaymentPercent;
    }

    updateInitialPayment() {

      this.setInitialPaymentPercent(this.initialPayment);

    }

  }
</script>
